(function(){
  "use strict";

  /* ═══════════════════════════════════════════════════════════
     KONFIGURATION — hier lassen sich alle Gewichte anpassen.
     Werte = Jahres-Offset. Negativ wirkt verjüngend.
     Größenordnungen orientieren sich an epidemiologischen
     Studien (Rauchen > Bewegung/BMI > Ernährung/Schlaf > Rest).
     ═══════════════════════════════════════════════════════════ */
  var CFG = {
    rauchen:        { label:"Rauchen",             map:[-1.0, 0.0, 1.5, 3.0, 5.0, 8.0] },
    ausdauer:       { label:"Ausdauerbewegung",    map:[ 3.0, 1.0,-1.5,-2.5] },
    kraft:          { label:"Krafttraining",       map:[ 1.5, 0.0,-1.5,-2.0] },
    gemuese:        { label:"Gemüse & Obst",       map:[ 2.0, 0.5,-1.0,-2.0] },
    verarbeitet:    { label:"Verarbeitete Kost",   map:[ 2.5, 1.5, 0.0,-1.5] },
    alkohol:        { label:"Alkohol",             map:[-0.5, 0.0, 1.0, 2.5, 5.0] },
    schlafdauer:    { label:"Schlafdauer",         map:[ 3.0, 1.5,-1.5, 1.0] },
    schlafqualitaet:{ label:"Schlafqualität",      map:[ 2.0, 1.0,-0.5,-1.5] },
    stress:         { label:"Stressbelastung",     map:[ 3.0, 1.5, 0.0,-1.5] },
    sozial:         { label:"Soziale Bindungen",   map:[ 2.0, 0.5,-1.0,-1.5] },
    energie:        { label:"Energie im Alltag",   map:[ 2.0, 1.0,-0.5,-1.5] }
  };

  function bmiOffset(bmi){
    if(bmi < 18.5) return { v: 1.5 };
    if(bmi < 25)   return { v:-1.0 };
    if(bmi < 30)   return { v: 0.5 };
    if(bmi < 35)   return { v: 2.5 };
    if(bmi < 40)   return { v: 5.0 };
    return           { v: 8.0 };
  }

  var TIPS = {
    rauchen:        "Ein Rauchstopp ist der wirksamste einzelne Schritt. Schon nach wenigen Jahren nähert sich das Risiko dem von Nierauchern an.",
    ausdauer:       "Zielmarke sind etwa 150 Minuten moderate Bewegung pro Woche. Drei zügige Spaziergänge à 30 Minuten sind ein realistischer Einstieg.",
    kraft:          "Zwei kurze Krafteinheiten pro Woche genügen bereits. Muskelmasse ist einer der stärksten Prädiktoren für gesundes Altern.",
    gemuese:        "Fünf Portionen am Tag sind die Zielmarke. Am einfachsten gelingt es, wenn bei jeder Mahlzeit eine Portion dabei ist.",
    verarbeitet:    "Nicht alles auf einmal streichen. Ein Austausch reicht zum Start, etwa Softdrinks durch Wasser oder Tee.",
    alkohol:        "Weniger ist durchgehend günstiger. Mehrere alkoholfreie Tage pro Woche sind ein wirksamer erster Schritt.",
    schlafdauer:    "Sieben bis acht Stunden sind der günstigste Bereich. Eine feste Aufstehzeit stabilisiert den Rhythmus schneller als eine feste Zubettgehzeit.",
    schlafqualitaet:"Kühles, dunkles Schlafzimmer, kein Bildschirm in der letzten Stunde und möglichst kein Alkohol am Abend verbessern die Tiefschlafphasen.",
    stress:         "Entscheidend ist nicht weniger Belastung, sondern verlässliche Erholung. Kurze tägliche Pausen wirken besser als seltene lange.",
    sozial:         "Regelmäßiger Kontakt zählt mehr als die Anzahl der Kontakte. Ein fester wöchentlicher Termin mit einem Menschen genügt als Anfang.",
    energie:        "Anhaltende Erschöpfung sollte ärztlich abgeklärt werden, insbesondere Eisen, Vitamin B12, Vitamin D und die Schilddrüse.",
    bmi:            "Schon 5 bis 10 Prozent Gewichtsreduktion verbessern Stoffwechselwerte deutlich messbar."
  };

  var TOTAL_Q = 14;
  var form      = document.getElementById("nanForm");
  var ageEl     = document.getElementById("nanAge");
  var heightEl  = document.getElementById("nanHeight");
  var weightEl  = document.getElementById("nanWeight");
  var submitBtn = document.getElementById("nanSubmit");
  var hintEl    = document.getElementById("nanHint");
  var progEl    = document.getElementById("nanProgress");
  var countEl   = document.getElementById("nanCount");
  var resultEl  = document.getElementById("nanResult");

  function validAge(){
    var v = parseInt(ageEl.value,10);
    return !isNaN(v) && v >= 18 && v <= 99;
  }
  function validBody(){
    var h = parseInt(heightEl.value,10), w = parseInt(weightEl.value,10);
    return !isNaN(h) && h >= 120 && h <= 230 && !isNaN(w) && w >= 35 && w <= 250;
  }
  function answeredCount(){
    var n = 0;
    if(validAge()) n++;
    if(form.querySelector('input[name="geschlecht"]:checked')) n++;
    if(validBody()) n++;
    Object.keys(CFG).forEach(function(key){
      if(form.querySelector('input[name="'+key+'"]:checked')) n++;
    });
    return n;
  }
  function markAnswered(){
    Array.prototype.forEach.call(form.querySelectorAll(".q"), function(q){
      var key = q.getAttribute("data-q"), ok;
      if(key === "alter") ok = validAge();
      else if(key === "koerper") ok = validBody();
      else ok = !!form.querySelector('input[name="'+key+'"]:checked');
      q.setAttribute("data-answered", ok ? "1" : "0");
    });
  }
  function updateProgress(){
    var n = answeredCount();
    countEl.textContent = n;
    progEl.style.width = Math.round((n / TOTAL_Q) * 100) + "%";
    markAnswered();
    var ready = (n === TOTAL_Q);
    submitBtn.disabled = !ready;
    hintEl.textContent = ready
      ? "Alle Fragen beantwortet."
      : "Noch " + (TOTAL_Q - n) + " Frage" + ((TOTAL_Q - n) === 1 ? "" : "n") + " offen.";
  }

  form.addEventListener("input", updateProgress);
  form.addEventListener("change", updateProgress);

  function calculate(){
    var age = parseInt(ageEl.value,10);
    var h   = parseInt(heightEl.value,10) / 100;
    var w   = parseInt(weightEl.value,10);
    var bmi = w / (h*h);

    var factors = [], raw = 0;

    var b = bmiOffset(bmi);
    raw += b.v;
    factors.push({ key:"bmi", label:"Körpergewicht (BMI " + bmi.toFixed(1) + ")", value:b.v });

    Object.keys(CFG).forEach(function(key){
      var sel = form.querySelector('input[name="'+key+'"]:checked');
      if(!sel) return;
      var val = CFG[key].map[parseInt(sel.value,10)];
      raw += val;
      factors.push({ key:key, label:CFG[key].label, value:val });
    });

    /* Dämpfung: tanh-Kompression gegen eine altersabhängige Obergrenze.
       Nahe null nahezu linear, an den Rändern sanft sättigend. */
    var maxDev = Math.min(16, Math.max(6, age * 0.28));
    var compressed = maxDev * Math.tanh(raw / maxDev);

    var bioAge = age + compressed;
    bioAge = Math.max(bioAge, Math.max(18, age * 0.6));
    bioAge = Math.min(bioAge, 110);

    return { age:age, bmi:bmi, bioAge:bioAge, raw:raw, delta:bioAge - age, factors:factors, maxDev:maxDev };
  }

  function render(r){
    var rounded = Math.round(r.bioAge);
    document.getElementById("nanBioAge").textContent = rounded;

    var d = rounded - r.age;
    var deltaEl = document.getElementById("nanDelta");
    if(d === 0){
      deltaEl.textContent = "Genau auf Höhe deines kalendarischen Alters von " + r.age;
    } else if(d < 0){
      deltaEl.textContent = Math.abs(d) + " Jahr" + (Math.abs(d)===1?"":"e") + " jünger als dein kalendarisches Alter";
    } else {
      deltaEl.textContent = d + " Jahr" + (d===1?"":"e") + " älter als dein kalendarisches Alter";
    }

    document.getElementById("nanChronoLabel").textContent = "kalendarisch " + r.age;
    var pct = 50 + (r.delta / r.maxDev) * 50;
    pct = Math.max(2, Math.min(98, pct));
    document.getElementById("nanMarkerChrono").style.left = "50%";
    document.getElementById("nanMarkerBio").style.left = pct + "%";

    var sorted = r.factors.slice().sort(function(a,b){ return Math.abs(b.value) - Math.abs(a.value); });
    var maxAbs = Math.max.apply(null, sorted.map(function(f){ return Math.abs(f.value); })) || 1;
    var list = document.getElementById("nanFactorList");
    list.innerHTML = "";
    sorted.forEach(function(f){
      var row = document.createElement("div");
      row.className = "factor";
      var widthPct = (Math.abs(f.value) / maxAbs) * 100;
      var cls = f.value < 0 ? "pos" : (f.value > 0 ? "neg" : "neutral");
      var color = f.value < 0 ? "#5f9e77" : (f.value > 0 ? "#c9635b" : "#9e9ca3");
      var side = f.value < 0
        ? 'right:50%;width:'+(widthPct/2)+'%;background:'+color+';'
        : 'left:50%;width:'+(widthPct/2)+'%;background:'+color+';';
      var sign = f.value > 0 ? "+" : (f.value < 0 ? "−" : "±");
      row.innerHTML =
        '<span class="fname"></span>' +
        '<span class="fbar"><span style="'+side+'"></span></span>' +
        '<span class="fval '+cls+'">'+sign+Math.abs(f.value).toFixed(1)+' J.</span>';
      row.querySelector(".fname").textContent = f.label;
      list.appendChild(row);
    });

    var levers = sorted.filter(function(f){ return f.value > 0; }).slice(0,3);
    var lv = document.getElementById("nanLeverList");
    lv.innerHTML = "";
    if(levers.length === 0){
      var li0 = document.createElement("li");
      li0.innerHTML = "<strong>Es gibt aktuell keinen Faktor, der dich rechnerisch belastet.</strong> Deine Angaben liegen in allen abgefragten Bereichen im günstigen Bereich. Bleib dran.";
      lv.appendChild(li0);
    } else {
      levers.forEach(function(f){
        var li = document.createElement("li");
        var strong = document.createElement("strong");
        strong.textContent = f.label + " (aktuell +" + f.value.toFixed(1) + " Jahre)";
        li.appendChild(strong);
        li.appendChild(document.createTextNode(TIPS[f.key] || ""));
        lv.appendChild(li);
      });
    }

    resultEl.classList.add("show");
    resultEl.focus({ preventScroll:true });
    resultEl.scrollIntoView({ behavior:"smooth", block:"start" });
  }

  form.addEventListener("submit", function(ev){
    ev.preventDefault();
    if(answeredCount() !== TOTAL_Q) return;
    render(calculate());
  });

  document.getElementById("nanReset").addEventListener("click", function(){
    form.reset();
    resultEl.classList.remove("show");
    updateProgress();
    form.scrollIntoView({ behavior:"smooth", block:"start" });
  });

  updateProgress();
})();
